module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69584/img/blog-post-zero.png"